import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Contact = () => {
  return (
    <React.Fragment>
      <SEO title="Contact | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Contact"
        content="The Conference"
        contentTwo="Contact"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="contact">
          <h3 className="entry-title">DMBD Conference Secretariat</h3>
          <li>
            <img src="./images/icons/person.png" width="20px" />
            <b>	&nbsp;Contact person:</b> Mr.Yan Wenbo
          </li>
          <li>
            <img src="./images/icons/email.png" width="20px" />
            <b> &nbsp;Email:</b>{" "}
            <a href="mailto: dmbd2024@iasei.org">dmbd2025@iasei.org</a>
          </li>
          <li>
            <img src="./images/icons/call.png" width="20px" />
            <b> &nbsp;TEL.:</b> (+86) 15701261174
          </li>
          {/* <li>
            <img src="./images/icons/twitter.png" width="20px" />
            <b> &nbsp;Twitter:</b> @dmbd202355969
          </li> */}

          <li></li>
        </div>
        <div className="entry-content">
          <table className="wechat">
            <thead>
              <tr>
                <th>WeChat: DMBD_Secretariat</th>
                {/* <th>WeChat Group for participants: </th>
                <th>WeChat Subscription: 国际群体智能会议ICSI</th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <img
                    src="./images/contact/dmbd.jpg"
                    className="header-image"
                    alt="DMBD 2025"
                    width="250px"
                  />
                </td>
                {/* <td>
                  <object className="wechat-svg" data="./images/svg/arrow.svg" type="image/svg+xml"></object>

                    <h4 className="wechat">Add this WeChat and you will be pulled into the WeChat group</h4>
                  </td>
                <td>
                  <img
                    src="./images/contact/wechat-subscription.jpg"
                    className="header-image"
                    alt="ICSI 2022"
                    width="250px"
                  />
                </td> */}

              </tr>
            </tbody>
          </table>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Contact;
